import { put, takeEvery, all } from "redux-saga/effects";
import * as assetTransferActions from "./action";
import {
  GET_TRANSFER_TYPE_DROPDOWN,
  GET_DIVISION_DROPDOWN,
  GET_COSTCENTER_DROPDOWN
} from "./types";

function* getTransferTypeDropdown(): any {
  try {
    const response = [
      { value: "Capital Lease", text: "Capital Lease" },
      { value: "Operating Lease", text: "Operating Lease" },
      { value: "Purchase", text: "Purchase" },
    ];
    const defaultTransferTypeDropdownOption: any = {
      text: "Select",
      value: null,
    };
    response.unshift(defaultTransferTypeDropdownOption);
    yield put(assetTransferActions.setTransferTypeDropdown(response));
  } catch (error) {
    yield put(assetTransferActions.setTransferTypeDropdown([]));
  }
}
function* getDivisionDropdown(): any {
  try {
    const response = [
      { value: "Capital Lease", text: "Capital Lease" },
      { value: "Operating Lease", text: "Operating Lease" },
      { value: "Purchase", text: "Purchase" },
    ];
    const defaultDivisionDropdownOption: any = {
      text: "Select",
      value: null,
    };
    response.unshift(defaultDivisionDropdownOption);
    yield put(assetTransferActions.setDivisionDropdown(response));
  } catch (error) {
    yield put(assetTransferActions.setDivisionDropdown([]));
  }
}
function* getCostCenterDropdown(): any {
  try {
    const response = [
      { value: "Capital Lease", text: "Capital Lease" },
      { value: "Operating Lease", text: "Operating Lease" },
      { value: "Purchase", text: "Purchase" },
    ];
    const defaultCostCenterDropdownOption: any = {
      text: "Select",
      value: null,
    };
    response.unshift(defaultCostCenterDropdownOption);
    yield put(assetTransferActions.setCostCenterDropdown(response));
  } catch (error) {
    yield put(assetTransferActions.setCostCenterDropdown([]));
  }
}
function* assetTransferSagaWatcher() {
  yield takeEvery(GET_TRANSFER_TYPE_DROPDOWN, getTransferTypeDropdown);
  yield takeEvery(GET_DIVISION_DROPDOWN, getDivisionDropdown);
  yield takeEvery(GET_COSTCENTER_DROPDOWN, getCostCenterDropdown);
}

export default function* combinedSaga() {
  yield all([assetTransferSagaWatcher()]);
}
